export default "__VITE_ASSET__ef145502__"